export const copyButtonStyles = () => ({
  '.MuiButtonBase-root': {
    padding: '5px',
    color: 'inherit',
    width: '24px',
    height: '24px',
    minWidth: '24px',
    borderRadius: '500px',
    '.MuiSvgIcon-root': {
      color: 'inherit',
      fontSize: '15px',
    },
  },
});
